// Multiresources are virtual resources stored in the same `resources` collection as real
// courts/rooms, told apart by `type`. They hold `resources: [resourceId]` and must never be
// listed where a bookable resource is expected — see docs/features/multiresources.md.
export const MULTIRESOURCE_TYPE = 'multiresource'

export const isMultiResource = (resource) => !!resource && resource.type === MULTIRESOURCE_TYPE

const isMultiResourceDoc = (doc) => isMultiResource(doc.data())

// Day resources (päiväresurssit) are booked per calendar day in their own calendar
// (docs/features/day-resources.md); like multiresources they must stay out of every hourly
// calendar, picker and price list.
export const DAYRESOURCE_TYPE = 'dayresource'

export const isDayResource = (resource) => !!resource && resource.type === DAYRESOURCE_TYPE

const isDayResourceDoc = (doc) => isDayResource(doc.data())

// Resources booked per hour/minute: everything except multiresources and day resources.
export const isPhysicalResourceDoc = (doc) => !isMultiResourceDoc(doc) && !isDayResourceDoc(doc)

// Returns a QuerySnapshot look-alike holding only the docs that pass `keep`. Callers of
// getResourses()/listenResourses() use only docs, empty, size and forEach.
export const filterSnap = (snap, keep) => {
  const docs = snap.docs.filter(keep)
  return {
    docs,
    empty: docs.length === 0,
    size: docs.length,
    forEach: (cb, thisArg) => docs.forEach(cb, thisArg),
  }
}

export const keepMultiResourceDoc = isMultiResourceDoc

export const keepDayResourceDoc = isDayResourceDoc
